import allCases from '../../fields/cases/allCases';

export const QUERY_GET_ALL_OC_CASES = /* GraphQL */ `
	query($limit: Float, $offset: Float, $filter: OperatingCostCaseFilter, $notEqual: OperatingCostCaseFilter) {
		getAllOperatingCostCase(
			limit: $limit
			offset: $offset
			filter: $filter
			notEqual: $notEqual
		) {
			items {
				${allCases}
			}
			total
		}
	}
`;
